export const route = {
  basename: "/mng/ctrl",
};

export const IMAGE_ACCEPT = ".jpg,.jpeg,.png,.bmp";
